import { Connection, PublicKey } from "@solana/web3.js";
import { getAllSymbols } from "Datafeed";
import { makeApiRequest } from "Datafeed/helpers";
const BN = require("bn.js");

export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const USDT_MINT = "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB";
export const SOL_MINT = "So11111111111111111111111111111111111111112";
export const TOKEN_PROGRAM_ID = "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA";

export function coinInfo(coinInfo) {
    return {
        symbol: coinInfo.symbol,
        decimals: coinInfo.decimals,
        mintAddress: coinInfo.symbol === "SOL" ? "11111111111111111111111111111111" : coinInfo.address,
        coingeckoId: (coinInfo.extensions && coinInfo.extensions.coingeckoId) ? coinInfo.extensions.coingeckoId : null,
    }
}

export function findCoinFrom(tokenList, symbol:any = null, mint:any = null) {
    if (!tokenList)
        return null;
    for(let i = 0; i < tokenList.length; i++)
        if(tokenList[i].symbol === symbol || tokenList[i].address == mint)
            return { ...coinInfo(tokenList[i]),...tokenList[i]}
    return null;
}

export async function getCoingeckoPrice(token) {
    if (!token || !token.coingeckoId)
        return 0;
    let rawPrice = await fetch("https://api.coingecko.com/api/v3/simple/price?ids="+token.coingeckoId+"&vs_currencies=USD")
        .catch(e => null);
    if (!rawPrice)
        return 0;
    let price = await rawPrice.json().catch(e => null);
    if (!price)
        return 0;
    return price[token.coingeckoId].usd;
}

export async function getMultipleCoingeckoPrice(accounts) {
    let coingeckoUrl = "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=";
    coingeckoUrl += accounts.map(x => x.coingeckoId).filter(x => x).join(",");
    coingeckoUrl += "&order=market_cap_desc&per_page=250&page=1&sparkline=false";
    let birdeyeAssets = await getAllSymbols();
    let coingekoPrice: any[] = [];
    try {
        coingekoPrice = await (await fetch(coingeckoUrl)).json();
    } catch (e: any) {
        console.log(e);
    }
    let filteredAccounts = accounts.filter(x => (birdeyeAssets // Wrapped BTC portal
        .find(y => y.address == x.mint) && x.mint != "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh")
    );
    let priceBirdEye = {};
    let reqs: Promise<any>[] = [];
    let batch = 150;
    for (let j = 0; j < Math.floor((filteredAccounts.length + batch - 1) / batch); j++) {
        let birdEyeRequest = "defi/multi_price?list_address=";
        birdEyeRequest += filteredAccounts
            .slice(j*batch, Math.min(j*batch + batch,filteredAccounts.length))
            .map(x => x.mint).join(",");
        reqs.push(makeApiRequest(birdEyeRequest).catch(e => {return {data: {}}}));
    }
    (await Promise.all(reqs)).map(res => priceBirdEye = {...priceBirdEye, ...res.data});
    for (let i=0;i<accounts.length; i++) {
        let resp = coingekoPrice.find(x => x.id == accounts[i].coingeckoId);
        if (resp) {
            accounts[i].usdValue = resp.current_price * accounts[i].balance;
            accounts[i].marketCap = resp.market_cap;
            accounts[i].volume = resp.total_volume;
            accounts[i].price = resp.current_price;
            accounts[i].change = resp.price_change_percentage_24h;
            accounts[i].changeAmount = resp.price_change_24h;
        }
        let respBirdEye = priceBirdEye[accounts[i].mint];
        if (respBirdEye) {
            accounts[i].usdValue = accounts[i].balance * respBirdEye.value;
            accounts[i].price = respBirdEye.value;
            accounts[i].change = respBirdEye.priceChange24h;
            accounts[i].changeAmount = respBirdEye.value - respBirdEye.value * 100 / (100 + respBirdEye.priceChange24h);
        }
    }
    return accounts;
}

export async function fetchUserAccounts(state) {
    if (!state.tokenList || !state.wallet || !state.wallet.publicKey)
        return [];
    let publicKey = state.wallet.publicKey;
    let accounts: any = [];
    accounts.push({
        address: publicKey.toBase58(),
        balance: (await state.connection.getBalance(publicKey, "processed").catch(() => 0)) / 10**9,
        mint: SOL_MINT,
        symbol: "SOL",
        coingeckoId: "solana",
        usdValue: 0,
        marketCap: 0,
        volume: 0,
        price: 0,
        change: 0,
        changeAmount: 0,
        isWrapped: false,
        tokenInfo: {
            ...findCoinFrom(state.tokenList.tokens, "SOL"),
            name: "Solana",
        }
    })
    let response = await state.connection.getTokenAccountsByOwner(
        publicKey,
        { programId: new PublicKey(TOKEN_PROGRAM_ID) },
        "processed"
    ).catch((e) => null);
    if (!response)
        return accounts;
    for (let i = 0; i < response.value.length; i++) {
        let mintPubkey = new PublicKey(response.value[i].account.data.slice(0, 32)).toBase58();
        let token = findCoinFrom(state.tokenList.tokens, null, mintPubkey);
        if (!token) continue;
        let amountString = new BN(response.value[i].account.data.slice(64, 72), "le").toString();
        accounts.push({
            symbol: token.symbol,
            address: response.value[i].pubkey.toBase58(),
            mint: mintPubkey,
            balance: parseInt(amountString) / 10 ** token.decimals,
            coingeckoId: token.coingeckoId,
            usdValue: 0,
            marketCap: 0,
            volume: 0,
            price: 0,
            change: 0,
            changeAmount: 0,
            isWrapped: (token.symbol.toUpperCase() == "SOL") ? true : false,
            tokenInfo: token,
        });
    }
    accounts = await getMultipleCoingeckoPrice(accounts);
    accounts.sort((a, b) => {
        return (b.usdValue > a.usdValue) ? 1 :
            ((b.usdValue < a.usdValue) ? -1 : b.balance - a.balance)
    });
    return accounts;
}

export function getTokenAccountAddressByMint(accounts, mint) {
    for (let i=0; i<accounts.length; i++)
        if (accounts[i].mint == mint)
            return accounts[i].address;
    return null;
}

export function findBalance(accounts, symbol) {
    if (!accounts || !symbol)
        return 0;
    for (let i=0; i<accounts.length; i++)
        if (accounts[i].symbol == symbol)
            return accounts[i].balance;
    return null;
}
